import React, { useState } from "react";
import { Button } from "../../Form/Button/Button";
import { UserSurveyAnswersModal } from "../UserSurveyAnswersModal/UserSurveyAnswersModal";
import './UserSurveyAnswersCell.scss';

/**
 * UserSurveyAnswersCell Component
 * 
 * Renders a button that opens a modal to show the user's survey answers.
 * Manages the modal state and handles the button click interaction.
 * 
 * @param {object} params - Component parameters
 * @param {object} params.user - The user object
 * @param {string} params.userId - The user's ID
 * @param {string} params.surveyId - The survey ID
 * @param {string} params.completedOnDate - When the user completed the survey
 * @param {boolean} params.isAnonymous - Whether the survey is anonymous
 * @param {object} params.i18n - Internationalization object
 * @param {boolean} [params.includeCorrectAnswer] - Whether to include correct answer data
 * @returns {JSX.Element} Rendered cell component
 */
export const UserSurveyAnswersCell = ({ user, userId, surveyId, completedOnDate, isAnonymous, i18n, includeCorrectAnswer }) => {
    const [modalOpen, setModalOpen] = useState(false);

    /**
     * Opens the user survey answers modal
     */
    const handleShowUserAnswer = () => {
        setModalOpen(true);
    };

    /**
     * Closes the user survey answers modal
     */
    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <div className="UserSurveyAnswersCell">
            <Button
                text={String(i18n.translate("surveyUsers.actions.showAnswer"))}
                size="small"
                variant={completedOnDate ? "contained" : "outlined"}
                color={completedOnDate ? "primary" : "default"}
                disabled={!completedOnDate || isAnonymous}
                onClick={handleShowUserAnswer}
            />
            <UserSurveyAnswersModal
                modalOpen={modalOpen}
                closeModal={closeModal}
                userId={userId}
                surveyId={surveyId}
                user={user}
                includeCorrectAnswer={includeCorrectAnswer}
            />
        </div>
    );
}; 